import React from "react";

function QuestionIconInline({ className, width = 16, height = 16 }) {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M27 11.35c1.18.38 2 1.5 2 2.8v5.7a2.9 2.9 0 0 1-2.64 2.93l-1.36.1V27l-4-4c-1.79 0-3.58-.07-5.36-.22a2.82 2.82 0 0 1-1.1-.32M27 11.35c-.2-.07-.42-.11-.63-.13-3.58-.3-7.16-.3-10.74 0A2.9 2.9 0 0 0 13 14.14v5.72c0 1.11.61 2.1 1.54 2.6M27 11.35v-2.5a4.3 4.3 0 0 0-3.68-4.31 64.6 64.6 0 0 0-16.64 0A4.3 4.3 0 0 0 3 8.84v8.31a4.3 4.3 0 0 0 3.68 4.31c.77.1 1.54.2 2.32.26V28l5.54-5.54"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default QuestionIconInline; 